import { render, staticRenderFns } from "./MenuModalHeader.vue?vue&type=template&id=44e52695"
import script from "./MenuModalHeader.vue?vue&type=script&lang=js"
export * from "./MenuModalHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports